import { Engine, HelperFunctions, State } from "../../tsthree";
import { Container, Graphics, NineSlicePlane, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { tsthreeConfig } from "../../config/tsthreeConfig";
import { ISlotData, PlayerDataSingleton } from "../Logic/PlayerDataSingleton";
import { GAME_FONT, GAME_FONT_BOLD, GAME_FONT_ITALIC } from "../Constants/Constants";
import { buttonify } from "../../engine/HelperFunctions/buttonify";
import { Windows95 } from "./Windows95";
import TaggedText from "pixi-tagged-text";
import { AUDIO_TYPES } from "../../engine/AudioSingleton";
import { openFullscreen } from "../../engine/HelperFunctions/fullscreenFunctions";
import { BootAssets } from "../../config/BootAssets";
import { CharacterPortraitGenerator } from "../Logic/CharacterPortraitGenerator";
import { CharacterCreatorDefinition } from "../Constants/CharacterCreatorDefinition";
import { GameModes } from "../Types/GameModes";
import { SearchbarPrefab } from "../Prefabs/SearchbarPrefab";
import { DropdownPrefab } from "../Prefabs/DropdownPrefab";
import { formatDateForCookie } from "../../engine/HelperFunctions/formatDateForCookie";
import { GAME_DEBUG_MODE } from "../../engine/Constants/Constants";
import { DoctorRanks } from "../Constants/DoctorRanks";
import { SkinColorsEnum } from "../Types/SkinColors";
import { SavedDataUpgradeFunctions } from "../Logic/SavedDataUpgradeFunctions";
import { IHospitalCore } from "../Types/IHospitalCore";
import { LoaderType } from "../../engine/Loaders/LoaderType";

const ModeStrings: Record<GameModes, { desc: string, title: string }> = {
    [GameModes.CASUAL]: {
        title: "Casual mode",
        desc: `- Examinations run in parallel
- Examinations take less time
- Better for fewer cases`,
    },
    [GameModes.REALISTIC]: {
        title: "Realistic mode",
        desc: `- Examinations are queued
- Examinations take longer
- Better for many cases
- +33% XP gain`,
    }
};

interface IDataSelectionUI {
    container: Container;
    portraitSlots: Sprite[];
    displayNameTexts: Text[];
    rankTexts: Text[];
    gameModeTexts: Text[];
    versionTexts: Text[];
    xpTexts: Text[];
    timestampTexts: Text[];
    slotContainers: Container[];
}

export class LoginScreen extends State {

    private _startTime: number = Number.MAX_SAFE_INTEGER;

    private _overlay: Graphics;

    private _loginPrompt: NineSlicePlane;

    private _stopTimers: boolean = false;

    private _musicId: string = "";

    private _currentlySelectedGameMode = GameModes.CASUAL;

    private _requiredFields: SearchbarPrefab[];
    private _createUserButtonIcon: Sprite;

    private _saveSelectMode: "new" | "load" = "new";
    private _activeSlot: -1 | 0 | 1 | 2 = -1;

    constructor() {
        super();
    }

    login(): boolean {
        return false;
        /*
        const params = (new URL(document.location.href)).search
            .substring(1)
            .split("&")
            .map((e) => {
                return {
                    key: e.substring(0, e.indexOf("=")),
                    value: e.substring(e.indexOf("=") + 1)
                };
            });
        const authKeyGoogle = params.find(
            (e) => e.key == "google_token"
        )?.value;
        const authKeyItch = params.find(
            (e) => e.key == "itch_token"
        )?.value;
        const authKey = authKeyGoogle || authKeyItch || "";
        const savedAuthKey = PlayerDataSingleton.getAuthKey();

        if(savedAuthKey) {
            if(authKey) {
                if(savedAuthKey !== authKey) {
                    PlayerDataSingleton.setAuthKey(
                        authKey,
                        authKeyGoogle ? "google" : "itch"
                    );
                    return true;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        } else {
            if(authKey) {
                PlayerDataSingleton.setAuthKey(
                    authKey,
                    authKeyGoogle ? "google" : "itch"
                );
                return true;
            } else {
                return false;
            }
        }
         */
    }

    onAwake(_engine: Engine, _params?: unknown): void {
        const isLoggedIn = this.login();
        const platform = isLoggedIn ? PlayerDataSingleton.getAuthPlatform() : "offline";

        const bg = new Sprite(
            ENGINE.getPIXIResource("DesktopBackground") as Texture
        );
        bg.anchor.set(0.5, 0);
        const scaleFactor = tsthreeConfig.height / bg.height;
        bg.scale.set(
            scaleFactor,
            scaleFactor,
        );
        bg.position.set(tsthreeConfig.width / 2, 0);
        this.getScene().addObject(bg);

        const overlay = this._overlay = new Graphics();
        overlay.beginFill(0x000000, 0.5);
        overlay.drawRect(0, 0, 128, 128);
        overlay.endFill();
        overlay.visible = false;
        overlay.width = tsthreeConfig.width;
        overlay.height = tsthreeConfig.height;
        this.getScene().addObject(overlay);

        const loginPrompt = this._loginPrompt = new NineSlicePlane(
            ENGINE.getPIXIResource("button") as Texture
        );
        loginPrompt.visible = false;
        loginPrompt.width = 320;
        loginPrompt.height = 310;
        loginPrompt.position.set(
            (tsthreeConfig.width / 2) - (loginPrompt.width / 2),
            (tsthreeConfig.height / 2) - (loginPrompt.height / 2),
        );
        this.getScene().addObject(loginPrompt);

        const headerBg = new Graphics();
        headerBg.beginFill(0x010081, 1);
        headerBg.drawRect(0, 0, loginPrompt.width - 5, 16);
        headerBg.endFill();
        headerBg.position.set(2, 1);
        loginPrompt.addChild(headerBg);

        const headerText = new Text("Login to DoctOS", new TextStyle({
            fontSize: 11,
            fontFamily: GAME_FONT_BOLD,
            fill: 0xffffff,
        }));
        headerText.position.set( 4 + 18, 3 );
        loginPrompt.addChild(headerText);
        const headerIcon = new Sprite(
            ENGINE.getPIXIResource("doctos-icon") as Texture
        );
        headerIcon.position.set( 2, 1);
        loginPrompt.addChild(headerIcon);

        // const offlineButtonContainer = new GameObject();
        const loadGameButtonBg = new NineSlicePlane(
            ENGINE.getPIXIResource("button") as Texture
        );
        loadGameButtonBg.width = 160;
        loadGameButtonBg.height = 32;
        loadGameButtonBg.position.set(
            -80 + (loginPrompt.width / 2),
            -6 + -40 + (loginPrompt.height * 0.8)
        );
        loginPrompt.addChild(loadGameButtonBg);
        const loadGameButtonText = new Text(
            "Load game",
            new TextStyle({
                fontFamily: GAME_FONT,
                fontSize: 11,
                fill: 0x000000,
            })
        );
        loadGameButtonText.anchor.set(0.5, 0.5);
        loadGameButtonText.position.set(
            loadGameButtonBg.x + (loadGameButtonBg.width / 2) + 16,
            loadGameButtonBg.y + (loadGameButtonBg.height / 2)
        );
        loginPrompt.addChild(loadGameButtonText);
        const loadGameButtonIcon = new Sprite(
            ENGINE.getPIXIResource("shutdown-icon") as Texture
        );
        loadGameButtonIcon.width = 23;
        loadGameButtonIcon.height = 23;
        loadGameButtonIcon.anchor.set(0.5, 0.5);
        loadGameButtonIcon.position.set(
            loadGameButtonText.position.x - (loadGameButtonText.width * loadGameButtonText.anchor.x) - 16,
            loadGameButtonText.position.y + 1,
        );
        loginPrompt.addChild(loadGameButtonIcon);

        const newGameButtonBg = new NineSlicePlane(
            ENGINE.getPIXIResource("button") as Texture
        );
        newGameButtonBg.width = 160;
        newGameButtonBg.height = 32;
        newGameButtonBg.position.set(
            -80 + (loginPrompt.width / 2),
            -6 + -40 + (loginPrompt.height * 0.8) - 37
        );
        loginPrompt.addChild(newGameButtonBg);
        const newGameButtonText = new Text(
            "New game",
            new TextStyle({
                fontFamily: GAME_FONT,
                fontSize: 11,
                fill: 0x000000,
            })
        );
        newGameButtonText.anchor.set(0.5, 0.5);
        newGameButtonText.position.set(
            newGameButtonBg.x + (newGameButtonBg.width / 2) + 16,
            newGameButtonBg.y + (newGameButtonBg.height / 2)
        );
        loginPrompt.addChild(newGameButtonText);
        const newGameButtonIcon = new Sprite(
            ENGINE.getPIXIResource("shutdown-icon") as Texture
        );
        newGameButtonIcon.width = 23;
        newGameButtonIcon.height = 23;
        newGameButtonIcon.anchor.set(0.5, 0.5);
        newGameButtonIcon.position.set(
            newGameButtonText.position.x - (newGameButtonText.width * newGameButtonText.anchor.x) - 16,
            newGameButtonText.position.y + 1,
        );
        loginPrompt.addChild(newGameButtonIcon);

        const doctOSLogoBg = new NineSlicePlane(
            ENGINE.getPIXIResource("inner-container-nineslice") as Texture
        );
        doctOSLogoBg.width = 300;
        doctOSLogoBg.height = 82;
        doctOSLogoBg.position.set(
            -(doctOSLogoBg.width * 0.5) + (loginPrompt.width * 0.5), 24
        );
        loginPrompt.addChild(doctOSLogoBg);

        const doctOSLogo = new Sprite(ENGINE.getPIXIResource("doctos-logo") as Texture);
        HelperFunctions.smartScale2D({
            x: 286,
            y: null
        }, doctOSLogo);
        doctOSLogo.position.set(6, 10);
        doctOSLogoBg.addChild(doctOSLogo);

        const maintext = new Text(`
Welcome to The Diagnosis Game!
`, new TextStyle({
            fill: 0x000000,
            fontFamily: GAME_FONT_BOLD,
            fontSize: 11,
            align: "center"
        }));
        maintext.anchor.set(0.5);
        maintext.position.set(
            loginPrompt.width / 2,
            130
        );
        loginPrompt.addChild(maintext);

        const privacyInfo = new TaggedText(
            `By starting the game, you agree that usage statistics may be collected (don't worry, it's totally anonymous!)\nPrivacy policy can be read <hyperlink url="asdf">here</hyperlink>.`,
            {
                default:{
                    fontFamily: GAME_FONT_ITALIC,
                    fontSize: 11,
                    fill: 0x000000,
                    align: "justify-center",
                    wordWrapWidth: loginPrompt.width * 0.95,
                    wordWrap: true,
                },
                "hyperlink": {
                    fill: 0x0000ff,
                    textDecoration: "underline"
                },
            }
        );
        // privacyInfo.anchor.set(0.5, 1);
        privacyInfo.position.set(
            // incase you wonder how this works, 0.025 is half the spacing
            // from the sides so it ends up centered with a 0,0 anchor
            loginPrompt.width * 0.025,
            loginPrompt.height - privacyInfo.textContainer.height - 4
        );
        loginPrompt.addChild(privacyInfo);
        this.addPrivacyPolicyLink(privacyInfo);

        const createCharacterUI = LoginScreen.createNewGameUI(
            (_mode: GameModes) => this._currentlySelectedGameMode = _mode,
            (_slotData) => {
                if(this._activeSlot === -1) throw new Error("No active slot, what the fuck");
                _slotData.gameMode = this._currentlySelectedGameMode; // Doing it here because :shrug:?
                PlayerDataSingleton.setActiveSaveSlot(this._activeSlot);
                PlayerDataSingleton.setSlotDataToSlot(_slotData);
                // PlayerDataSingleton.initializeFromSlotData();
                this.goToDoctOSState();
            }
        );
        this._requiredFields = createCharacterUI.requiredFields;
        this._createUserButtonIcon = createCharacterUI.createUserButtonIcon;
        createCharacterUI.container.zIndex = 9999;
        this.scene.addObject(createCharacterUI.container);
        createCharacterUI.container.visible = false;

        if(!isLoggedIn) {
            HelperFunctions.playSound_s("High-End-Party", {
                loop: true,
                audioType: AUDIO_TYPES.MUSIC,
                volume: 0.2,
            }).then((e) => {
                if(e) {
                    this._musicId = e;
                }
            });
        }

        const selectDataUI = LoginScreen.createDataSelectionUI();
        this.scene.addObject(selectDataUI.container);
        buttonify(selectDataUI.slotContainers, {
            onFire: (ev) => {
                const target = ev.target;
                const ind: 0 | 1 | 2 | -1 =
                    selectDataUI.slotContainers.findIndex((e) => e == target) as 0 | 1 | 2 | -1;
                if(ind === -1) {
                    throw new Error("Invalid selected slot!");
                }
                if(this._saveSelectMode === "new") {
                    if(GAME_DEBUG_MODE) console.log("New game clicked on slot %i", ind);
                    // check if saved data already exists in the slot
                    if(PlayerDataSingleton.getSaveSlotDataRef(ind)?.gameVersion) {
                        // show "are you sure" prompt
                        // return;
                    }
                    // otherwise, show the character creator

                    // we gotta cache the ind because we can't push stuff to PlayerDataSingleton yet
                    // we want to have all the data setup before pushing it
                    this._activeSlot = ind;
                    createCharacterUI.portrait.update({
                        hairVal: 0
                    });
                    createCharacterUI.container.visible = true;
                    selectDataUI.container.visible = false;
                } else if(this._saveSelectMode === "load") {
                    // check if data exists
                    if(!PlayerDataSingleton.getSaveSlotDataRef(ind)?.gameVersion) {
                        return;
                    }
                    if(GAME_DEBUG_MODE) console.log("Load game clicked on slot %i", ind);
                    PlayerDataSingleton.setActiveSaveSlot(ind);
                    SavedDataUpgradeFunctions.upgradeData(PlayerDataSingleton, __VERSION);
                    // PlayerDataSingleton.initializeFromSlotData(
                    //     PlayerDataSingleton.getSaveSlotDataRef(ind)
                    // );
                    this.goToDoctOSState();
                } else {
                    throw new Error("Can't touch this");
                }
            }
        });
        selectDataUI.container.visible = false;

        LoginScreen.updateSlots(
            selectDataUI,
            [
                PlayerDataSingleton.getSaveSlotDataRef(0),
                PlayerDataSingleton.getSaveSlotDataRef(1),
                PlayerDataSingleton.getSaveSlotDataRef(2),
            ]
        );

        let antiSpam: boolean = false;
        buttonify(loadGameButtonBg, {
            onFire: () => {
                if(antiSpam) return;
                antiSpam = true;
                this._saveSelectMode = "load";
                ENGINE.initializeAnalytics();
                selectDataUI.container.visible = true;
                antiSpam = false;
            }
        });

        buttonify(newGameButtonBg, {
            onFire: () => {
                if(antiSpam) return;
                antiSpam = true;
                this._saveSelectMode = "new";
                ENGINE.initializeAnalytics();
                selectDataUI.container.visible = true;
                antiSpam = false;
            }
        });

        setTimeout(
            () => ENGINE.trackInitialLoadTime(),
            1
        );

        this._startTime = Date.now();
        _engine.getTicker().start();

        // if(
        //     GAME_DEBUG_MODE &&
        //     PlayerDataSingleton.hasSaveSlot(0)
        // ) {
        //     PlayerDataSingleton.setActiveSaveSlot(0);
        //     ENGINE.changeState(
        //         new Windows95(),
        //     );
        // }
    }

    private static updateSlots(
        _dataUI: IDataSelectionUI,
        _initialData: Record<0 | 1 | 2, ISlotData>
    ): void {
        const portraitGen = new CharacterPortraitGenerator();
        for (let _i = 0; _i < 3; _i++) {
            const i: 0 | 1 | 2 = _i as 0 | 1 | 2;
            const data = _initialData[i];
            if(!data || !data.gameVersion)
                continue;

            if(data.characterCreatorSettings) {
                portraitGen.update(data.characterCreatorSettings);
                _dataUI.portraitSlots[i].texture = portraitGen.createPortraitTexture();
            }

            if(typeof data.timestamp !== "undefined") {
                _dataUI.timestampTexts[i].text = formatDateForCookie(data.timestamp);
            }

            if(typeof data.displayName !== "undefined") {
                const split = data.displayName
                    .split(" ");
                const firstName = split.slice(0, Math.max(split.length - 2, 1));
                const lastName = split[split.length - 1];
                _dataUI.displayNameTexts[i].text = `${lastName}, ${firstName}`;
            }

            if(typeof data?.docScore !== "undefined") {
                _dataUI.xpTexts[i].text = `${data.docScore} XP`;
                const docRankIndex = DoctorRanks.findIndex(
                    (e) => e.threshold > data.docScore) - 1;
                const rankData = DoctorRanks[
                    docRankIndex
                ];
                _dataUI.rankTexts[i].text = `${rankData.name} - Level ${docRankIndex + 1}`;
            }

            if(typeof data?.gameVersion !== "undefined") {
                _dataUI.versionTexts[i].text = `v${data.gameVersion}`;
            }

            if(typeof data?.gameMode !== "undefined") {
                if(data.gameMode === GameModes.CASUAL) {
                    _dataUI.gameModeTexts[i].text = "Casual";
                    _dataUI.gameModeTexts[i].style.fill = "#006600";
                } else if(data.gameMode === GameModes.REALISTIC) {
                    _dataUI.gameModeTexts[i].text = "Realistic";
                    _dataUI.gameModeTexts[i].style.fill = "#660000";
                }
            }
        }
    }

    public goToDoctOSState(): Promise<void> {
        ENGINE.getWASM<IHospitalCore>("HospitalCore").setCurrentGameMode(
            PlayerDataSingleton.getGameMode()
        );
        console.log("Gamemode is set to %i",
            ENGINE.getWASM<IHospitalCore>("HospitalCore").getCurrentGameMode());
        return ENGINE.changeState(
            new Windows95()
        );
    }

    private async tryLogin(type: "google" | "itch" | "offline"): Promise<void> {
        if(type === "offline") {
            const prom = PlayerDataSingleton.getShouldAutoFullscreen() ?
                openFullscreen() : Promise.resolve();
            await prom.then(() => {
                this.goToDoctOSState();
            });
            return;
        } else {
            console.error("Other types not yet implemented");
            return;
        }
    }

    private addPrivacyPolicyLink(_target: TaggedText): void {
        _target.textFields.forEach((e) => {
            // @ts-ignore
            if(e.style?.url) {
                buttonify(e, {
                    onFire: () => {
                        window.open("https://slynch.xyz/privacy.html", '_blank').focus();
                    },
                    onPointerOver: () => {

                    },
                    onPointerOut: () => {

                    }
                });
            }
        });
    }

    onDestroy(_engine: Engine) {
        super.onDestroy(_engine);
        HelperFunctions.stopAllSoundsOfId("High-End-Party");
    }

    onStep(_engine: Engine) {
        super.onStep(_engine);
        if(this._overlay && !this._stopTimers) {
            if(Date.now() > this._startTime + (1000 * 0.8)) {
                this._overlay.visible = true;
            }
            if(Date.now() > this._startTime + (1000 * 1)) {
                // if(this._shouldAutoLogin) {
                    // const loggedIn = this.login();
                    // if(loggedIn) {
                    //     (
                    //         PlayerDataSingleton.getShouldAutoFullscreen() ? openFullscreen() : Promise.resolve()
                    //     )
                    //     .catch()
                    //     .then((e) => {
                    //         ENGINE.changeState(
                    //             new Windows95()
                    //         );
                    //     });
                    // } else {
                    // this._loginPrompt.visible = true;
                    // }
                // } else {
                    this._loginPrompt.visible = true;
                // }
                if(ENGINE["_loadingScrObject"]) {
                    ENGINE["_loadingScrObject"].visible = false;
                }
                this._stopTimers = true;
            }
        }
        if(this._createUserButtonIcon) {
            if(
                !this._requiredFields?.find((e) => !e.currentText)
            ) {
                this._createUserButtonIcon.texture = ENGINE.getTexture(
                    "green-tick"
                );
            } else {
                this._createUserButtonIcon.texture = ENGINE.getTexture(
                    "warning-icon"
                );
            }
        }
    }

    preload(_engine: Engine): Promise<void> {
        const assets: typeof BootAssets = [];

        if(!_engine.hasPIXIResource("CharacterMakerSpritesheet")) {
            assets.push({
                key: "CharacterMakerSpritesheet",
                    path: "sprites/Spritesheets/charactermaker.json",
                type: LoaderType.PIXI,
            });
        }

        if(assets.length > 0) {
            return _engine.loadAssets(assets, (p) => {
                if(GAME_DEBUG_MODE) {
                    console.log("LoginScreen preload progress %i", p);
                }
            });
        } else {
            return Promise.resolve(undefined);
        }
    }

    static createNewGameUI(
        _onChangeMode: (_mode: GameModes) => void,
        _onCreateCharacter: (_slot: ISlotData) => void,
    ): {
        container: Container;
        requiredFields: SearchbarPrefab[],
        createUserButtonIcon: Sprite,
        portrait: CharacterPortraitGenerator
    } {
        const requiredFields: SearchbarPrefab[] = [];
        const sharedTextStyle = new TextStyle({
            fill: 0x070707,
            fontFamily: GAME_FONT_BOLD,
            fontSize: 11,
        });

        const mainContainer = new Container();
        mainContainer.interactive = true;
        mainContainer.interactiveChildren = true;

        const bg = new NineSlicePlane(
            ENGINE.getTexture("generic-container-nineslice")
        );
        bg.width = 400;
        bg.height = 455;
        bg.position.set(
            Math.floor((tsthreeConfig.width * 0.5) + (bg.width * -0.5)),
            Math.floor((tsthreeConfig.height * 0.5) + (bg.height * -0.5))
        );
        mainContainer.addChild(bg);

        const headerBg = new Graphics();
        headerBg.beginFill(0x0000ff, 1);
        headerBg.drawRect(0, 0, bg.width - 4, 16);
        headerBg.endFill();
        headerBg.position.set(2, 2);
        bg.addChild(headerBg);

        const headerIcon = new Sprite(ENGINE.getTexture("doctos-icon"));
        headerIcon.position.set(2, 0);
        headerBg.addChild(headerIcon);

        const headerText = new Text("Create new user", new TextStyle({
            fontFamily: GAME_FONT,
            fill: 0xfafafa,
            fontSize: 11,
            align: "left",
        }));
        headerText.position.set(22, 1);
        headerBg.addChild(headerText);

        const closeButton = new Sprite(ENGINE.getTexture("close-icon"));
        closeButton.position.set(headerBg.width - closeButton.width, 2);
        headerBg.addChild(closeButton);
        buttonify(closeButton, {
            onFire: () => {
                mainContainer.visible = false;
            }
        });

        const characterPortraitBg = new NineSlicePlane(
            ENGINE.getTexture("inner-container-nineslice")
        );
        characterPortraitBg.width = 128;
        characterPortraitBg.height = 128;
        characterPortraitBg.position.set(28, 40);
        bg.addChild(characterPortraitBg);

        let faceVal: number = 0;
        let mouthVal: number = 0;
        let noseVal: number = 0;
        let eyesVal: number = 0;
        let hairVal: number = 0;
        let eyebrowsVal: number = 0;
        let earsVal: number = 0;
        let hairColourVal: number = 0;
        let skinColourVal: number = SkinColorsEnum.Default;
        const characterPortrait = new CharacterPortraitGenerator({
            skinColor: SkinColorsEnum.Default,
            desaturateHair: false,
            hairTint: skinColourVal,
            hairVal: hairVal,
            earsVal: earsVal,
            eyesVal: eyesVal,
            noseVal: noseVal,
            faceVal: faceVal,
            mouthVal: mouthVal,
            eyebrowsVal: eyebrowsVal,
        });
        characterPortraitBg.addChild(characterPortrait);
        (function createSelectors() {
            const faceText = new Text("Face:", sharedTextStyle);
            faceText.position.set(20, 180);
            bg.addChild(faceText);
            const faceSelectionContainer = LoginScreen.createSelector(
                "faces",
                sharedTextStyle,
                (_val) => (
                    faceVal = _val,
                    characterPortrait.update({faceVal: _val})
                ),
                0
            );
            faceText.addChild(faceSelectionContainer);

            const mouthText = new Text("Mouth:", sharedTextStyle);
            mouthText.position.set(20, 200);
            bg.addChild(mouthText);
            const mouthSelectionContainer = LoginScreen.createSelector(
                "mouths",
                sharedTextStyle,
                (_val) => (
                    mouthVal = _val,
                    characterPortrait.update({mouthVal: _val})
                ),
                0
            );
            mouthText.addChild(mouthSelectionContainer);

            const noseText = new Text("Nose:", sharedTextStyle);
            noseText.position.set(20, 220);
            bg.addChild(noseText);
            const noseSelectionContainer = LoginScreen.createSelector(
                "noses",
                sharedTextStyle,
                (_val) => (
                    noseVal = _val,
                    characterPortrait.update({noseVal: _val})
                ),
                0
            );
            noseText.addChild(noseSelectionContainer);

            const eyesText = new Text("Eyes:", sharedTextStyle);
            eyesText.position.set(20, 240);
            bg.addChild(eyesText);
            const eyesSelectionContainer = LoginScreen.createSelector(
                "eyes",
                sharedTextStyle,
                (_val) => (
                    eyesVal = _val,
                    characterPortrait.update({eyesVal: _val})
                ),
                0
            );
            eyesText.addChild(eyesSelectionContainer);

            const hairsText = new Text("Hair:", sharedTextStyle);
            hairsText.position.set(20, 260);
            bg.addChild(hairsText);
            const hairsSelectionContainer = LoginScreen.createSelector(
                "hairfront",
                sharedTextStyle,
                (_val) => (
                    hairVal = _val,
                    characterPortrait.update({hairVal: _val})
                ),
                0
            );
            hairsText.addChild(hairsSelectionContainer);

            const eyebrowsText = new Text("Eyebrows:", sharedTextStyle);
            eyebrowsText.position.set(20, 280);
            bg.addChild(eyebrowsText);
            const eyebrowsSelectionContainer = LoginScreen.createSelector(
                "eyebrows",
                sharedTextStyle,
                (_val) => (
                    eyebrowsVal = _val,
                    characterPortrait.update({eyebrowsVal: _val})
                ),
                0
            );
            eyebrowsText.addChild(eyebrowsSelectionContainer);

            const earsText = new Text("Ears:", sharedTextStyle);
            earsText.position.set(20, 300);
            bg.addChild(earsText);
            const earsSelectionContainer = LoginScreen.createSelector(
                "earFronts",
                sharedTextStyle,
                (_val) => (
                    earsVal = _val,
                    characterPortrait.update({earsVal: _val})
                ),
                0
            );
            earsText.addChild(earsSelectionContainer);

            const hairColourText = new Text("Hair colour:", sharedTextStyle);
            hairColourText.position.set(20, 320);
            bg.addChild(hairColourText);
            const hairColourSelectionContainer = LoginScreen.createSelector(
                "hairtints",
                sharedTextStyle,
                (_val) => (
                    hairColourVal = _val,
                    characterPortrait.update({hairTint: _val})
                ),
                0
            );
            hairColourText.addChild(hairColourSelectionContainer);

            const skinColourText = new Text("Skin colour:", sharedTextStyle);
            skinColourText.position.set(20, 340);
            bg.addChild(skinColourText);
            const skinColourSelectionContainer = LoginScreen.createSelector(
                "skinColors",
                sharedTextStyle,
                (_val) => (
                    skinColourVal = _val,
                    characterPortrait.update({skinColor: _val})
                ),
                0
            );
            skinColourText.addChild(skinColourSelectionContainer);
        })();

        (function createModeSelector() {
            const modeSelectWidth = 172;
            const modeSelectionContainer = new Container();
            bg.addChild(modeSelectionContainer);
            const outlineGraphic = new Graphics();
            outlineGraphic.lineStyle(2, 0x9a9a9a);
            outlineGraphic.drawRect(0, 0, modeSelectWidth, 205);
            modeSelectionContainer.position.set(200, 179);
            modeSelectionContainer.addChild(outlineGraphic);

            const modeTitle = new Text(ModeStrings[GameModes.CASUAL].title, new TextStyle({
                align: "center",
                fontSize: 11,
                fontFamily: GAME_FONT_BOLD,
                fill: 0x0a0a0a,
            }));
            modeTitle.anchor.set(0.5, 0);
            modeTitle.position.set(modeSelectWidth * 0.5, 2);
            modeSelectionContainer.addChild(modeTitle);

            const modeDescription = new Text(
                ModeStrings[GameModes.CASUAL].desc,
                new TextStyle({
                    align: "left",
                    fontFamily: GAME_FONT,
                    fill: 0x0a0a0a,
                    fontSize: 11,
                })
            );
            modeDescription.anchor.set(0, 0.5);
            modeDescription.position.set(8, 56);
            modeSelectionContainer.addChild(modeDescription);

            const selectedModeGraphic = new Graphics();
            selectedModeGraphic.beginFill(0x0000ff);
            selectedModeGraphic.drawRect(-37, -37, 74, 94);
            selectedModeGraphic.endFill();
            modeSelectionContainer.addChild(selectedModeGraphic);

            const casualButtonBg = new NineSlicePlane(
                ENGINE.getTexture("generic-square-nineslice")
            );
            casualButtonBg.width = 64;
            casualButtonBg.height = 64;
            casualButtonBg.position.set(
                -(casualButtonBg.width * 0.5) + (modeSelectWidth * 0.5) - 37,
                -(casualButtonBg.height * 0.5) + 140
            );
            modeSelectionContainer.addChild(casualButtonBg);
            selectedModeGraphic.position.set(
                casualButtonBg.position.x + (casualButtonBg.width * 0.5),
                casualButtonBg.position.y + (casualButtonBg.height * 0.5)
            );
            const casualModeText = new Text("Casual", new TextStyle({
                fill: 0xfafafa,
                fontSize: 14,
                fontFamily: GAME_FONT_BOLD,
                align: "center",
            }));
            casualModeText.anchor.set(0.5);
            casualModeText.position.set(
                casualButtonBg.width * 0.5,
                casualButtonBg.height + 12
            );
            casualButtonBg.addChild(casualModeText);

            const realisticButtonBg = new NineSlicePlane(
                ENGINE.getTexture("generic-square-nineslice")
            );
            realisticButtonBg.width = 64;
            realisticButtonBg.height = 64;
            realisticButtonBg.position.set(
                -(realisticButtonBg.width * 0.5) + (modeSelectWidth * 0.5) + 37,
                -(realisticButtonBg.height * 0.5) + 140
            );
            modeSelectionContainer.addChild(realisticButtonBg);
            const realisticModeText = new Text("Realistic", new TextStyle({
                fill: 0x0a0a0a,
                fontSize: 14,
                fontFamily: GAME_FONT_BOLD,
                align: "center",
            }));
            realisticModeText.anchor.set(0.5);
            realisticModeText.position.set(
                realisticButtonBg.width * 0.5,
                realisticButtonBg.height + 12
            );
            realisticButtonBg.addChild(realisticModeText);

            buttonify(
                [
                    realisticButtonBg,
                    casualButtonBg
                ],
                {
                    onFire: (ev, _state) => {
                        if(ev.target === realisticButtonBg) {
                            selectedModeGraphic.position.set(
                                realisticButtonBg.position.x + (realisticButtonBg.width * 0.5),
                                realisticButtonBg.position.y + (realisticButtonBg.height * 0.5)
                            );
                            realisticModeText.style.fill = "#fafafa";
                            casualModeText.style.fill = "#0a0a0a";
                            modeTitle.text = ModeStrings[GameModes.REALISTIC].title;
                            modeDescription.text = ModeStrings[GameModes.REALISTIC].desc;
                            _onChangeMode(GameModes.REALISTIC);
                        } else if(ev.target === casualButtonBg) {
                            selectedModeGraphic.position.set(
                                casualButtonBg.position.x + (casualButtonBg.width * 0.5),
                                casualButtonBg.position.y + (casualButtonBg.height * 0.5)
                            );
                            casualModeText.style.fill = "#fafafa";
                            realisticModeText.style.fill = "#0a0a0a";
                            modeTitle.text = ModeStrings[GameModes.CASUAL].title;
                            modeDescription.text = ModeStrings[GameModes.CASUAL].desc;
                            _onChangeMode(GameModes.CASUAL);
                        } else {
                            console.warn("wut");
                        }
                    }
                });
        })();

        let firstNameTextField: SearchbarPrefab;
        let lastNameTextField: SearchbarPrefab;
        let hometownTextField: SearchbarPrefab;
        let birthDate_day: number = 1;
        let birthDate_month: number = 1;
        (function createTextFields(){
            const firstNameText = new Text("*First name:", sharedTextStyle);
            firstNameText.position.set(172, 60);
            bg.addChild(firstNameText);
            firstNameTextField = new SearchbarPrefab({
                onType(): void {},
                skipButtons: true,
                allowFreeInput: true,
                skipPreview: true,
                width: 120
            });
            requiredFields.push(firstNameTextField);
            firstNameTextField.position.set(
                140,
                -2
            );
            firstNameText.addChild(firstNameTextField);

            const lastNameText = new Text("*Last name:", sharedTextStyle);
            lastNameText.position.set(172, 80);
            bg.addChild(lastNameText);
            lastNameTextField = new SearchbarPrefab({
                onType(): void {},
                skipButtons: true,
                allowFreeInput: true,
                skipPreview: true,
                width: 120
            });
            requiredFields.push(lastNameTextField);
            lastNameTextField.position.set(
                140,
                -2
            );
            lastNameText.addChild(lastNameTextField);

            const hometownText = new Text("*Hometown:", sharedTextStyle);
            hometownText.position.set(172, 120);
            bg.addChild(hometownText);
            hometownTextField = new SearchbarPrefab({
                onType(): void {},
                skipButtons: true,
                allowFreeInput: true,
                skipPreview: true,
                width: 120
            });
            requiredFields.push(hometownTextField);
            hometownTextField.position.set(
                140,
                -2
            );
            hometownText.addChild(hometownTextField);

            const birthDateText = new Text("*Birth date:", sharedTextStyle);
            birthDateText.position.set(172, 100);
            bg.addChild(birthDateText);
            const birthDateTextField_day = new DropdownPrefab({
                onSelect(_selectedValue: string): void {
                    birthDate_day = parseInt(_selectedValue);
                },
                width: 40
            });
            birthDateTextField_day.position.set(
                80,
                -2
            );
            birthDateTextField_day.update(
                new Array(31)
                    .fill(null)
                    .map((e, i) => (i+1).toString()),
            );
            birthDateText.addChild(birthDateTextField_day);
            const months = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ];
            const birthDateTextField_month = new DropdownPrefab({
                onSelect(_selectedValue: string): void {
                    birthDate_month = months.findIndex((e) => e === _selectedValue) + 1;
                },
                width: 82
            });
            birthDateTextField_month.update(months);
            birthDateTextField_month.position.set(118, -2);
            birthDateText.addChild(birthDateTextField_month);
        })();

        const createUserButtonBg = new NineSlicePlane(
            ENGINE.getTexture("generic-square-nineslice")
        );
        createUserButtonBg.width = 100;
        createUserButtonBg.height = 40;
        createUserButtonBg.position.set(
            240,
            400
        );
        bg.addChild(createUserButtonBg);
        const createUserIcon = new Sprite(
            ENGINE.getTexture("warning-icon")
        );
        createUserIcon.anchor.set(1, 0.5);
        createUserIcon.position.set(24, 20);
        createUserButtonBg.addChild(createUserIcon);
        const createUserText = new Text("Create user", new TextStyle({
            fill: "#0a0a0a",
            fontFamily: GAME_FONT_BOLD,
            fontSize: 11,
        }));
        createUserText.anchor.set(0, 0.5);
        createUserText.position.set(27, 20);
        createUserButtonBg.addChild(createUserText);

        const createUserBlockPopupContainer = new Container();
        mainContainer.addChild(createUserBlockPopupContainer);
        const createUserBlockPopupBg = new NineSlicePlane(
            ENGINE.getTexture("popup_nineslice")
        );
        createUserBlockPopupBg.width = 96;
        createUserBlockPopupBg.height = 38;
        createUserBlockPopupContainer.addChild(createUserBlockPopupBg);
        const createUserBlockPopupText = new Text(
            "You must fill out all the fields!",
            new TextStyle({
                fontSize: 11,
                fill: "#0a0a0a",
                fontFamily: GAME_FONT,
                align: "center",
                wordWrap: true,
                wordWrapWidth: createUserBlockPopupBg.width - 6
            })
        );
        createUserBlockPopupText.position.set(4, 4);
        createUserBlockPopupBg.addChild(createUserBlockPopupText);
        createUserBlockPopupContainer.visible = false;

        let over: boolean = false;
        buttonify(createUserButtonBg, {
            onFire: () => {
                // create user here
                if(!over || (
                    createUserIcon.texture !== ENGINE.getTexture("green-tick")
                )) return;

                if(GAME_DEBUG_MODE) {
                    console.log("Can create character, doing so");
                }
                const emptySlot = PlayerDataSingleton.initializeEmptySlot();
                emptySlot.birthdate = {
                    day: birthDate_day,
                    month: birthDate_month,
                };
                emptySlot.hometown = hometownTextField.currentText;
                emptySlot.displayName = `${firstNameTextField.currentText} ${lastNameTextField.currentText}`;
                emptySlot.characterCreatorSettings = {
                    skinColor: skinColourVal,
                    earsVal,
                    eyebrowsVal,
                    eyesVal,
                    noseVal,
                    desaturateHair: false,
                    faceVal,
                    hairVal,
                    mouthVal,
                    hairTint: hairColourVal,
                };
                // emptySlot.gameMode = selectedGameMode;
                _onCreateCharacter(emptySlot);
            },
            onPointerMove: (ev) => {
                if(!over || (
                    createUserIcon.texture === ENGINE.getTexture("green-tick")
                )) return;
                const parsed = HelperFunctions.parseInteractionEvent(ev);
                createUserBlockPopupContainer.position.set(
                    parsed.x + 10,
                    parsed.y - 40,
                );
            },
            onPointerOver: () => {
                over = true;
                createUserBlockPopupContainer.visible =
                    over && (
                        createUserIcon.texture !== ENGINE.getTexture("green-tick")
                    );
            },
            onPointerOut: () => {
                over = false;
                createUserBlockPopupContainer.visible = false;
            }
        });

        return {
            container: mainContainer,
            requiredFields: requiredFields,
            createUserButtonIcon: createUserIcon,
            portrait: characterPortrait
        };
    }

    static createSelector(
        _key: keyof (typeof CharacterCreatorDefinition),
        _textStyle: TextStyle,
        _onUpdate: (_val: number) => void,
        _initialVal: number = 1
    ): Container {
        let selectedVal =
            typeof _initialVal !== "undefined" ?
                _initialVal
                :
                1;
        const selectionContainer = new Container();
        selectionContainer.position.set(100, 0);
        const faceUp = new Sprite(ENGINE.getTexture("up-arrow"));
        selectionContainer.addChild(faceUp);
        faceUp.position.set(16 + 24, 0);
        const faceDown = new Sprite(ENGINE.getTexture("down-arrow"));
        selectionContainer.addChild(faceDown);
        const numContainer = new NineSlicePlane(
            ENGINE.getTexture("inner-container-nineslice")
        );
        numContainer.width = 26;
        numContainer.height = 20;
        numContainer.position.set(15, -1);
        selectionContainer.addChild(numContainer);
        const numText = new Text(selectedVal.toString(), _textStyle);
        numText.anchor.set(0.5);
        numText.position.set(
            numContainer.width * 0.5,
            numContainer.height * 0.5,
        );
        numContainer.addChild(numText);
        buttonify(faceUp, {
            onFire: () => {
                selectedVal = Math.min(
                    selectedVal + 1,
                    CharacterCreatorDefinition[_key].length - 1
                );
                numText.text = selectedVal.toString();
                _onUpdate(selectedVal);
            }
        });
        buttonify(faceDown, {
            onFire: () => {
                selectedVal = Math.max(
                    selectedVal - 1,
                    0
                );
                numText.text = selectedVal.toString();
                _onUpdate(selectedVal);
            }
        });

        return selectionContainer;
    }

    static createAreYouSurePrompt(): {
        container: Container
    } {
        const retVal = {
            container: null as Container
        };

        // todo

        return retVal;
    }

    static createDataSelectionUI(): IDataSelectionUI {
        const mainContainer = new Container();
        mainContainer.interactive = true;
        mainContainer.interactiveChildren = true;

        const bg = new NineSlicePlane(
            ENGINE.getTexture("generic-container-nineslice")
        );
        bg.width = 400;
        bg.height = 400;
        bg.position.set(
            Math.floor((tsthreeConfig.width * 0.5) + (bg.width * -0.5)),
            Math.floor((tsthreeConfig.height * 0.5) + (bg.height * -0.5))
        );
        mainContainer.addChild(bg);

        const headerBg = new Graphics();
        headerBg.beginFill(0x0000ff, 1);
        headerBg.drawRect(0, 0, bg.width - 4, 16);
        headerBg.endFill();
        headerBg.position.set(2, 2);
        bg.addChild(headerBg);

        const headerIcon = new Sprite(ENGINE.getTexture("doctos-icon"));
        headerIcon.position.set(2, 0);
        headerBg.addChild(headerIcon);

        const headerText = new Text("Select user account", new TextStyle({
            fontFamily: GAME_FONT,
            fill: 0xfafafa,
            fontSize: 11,
            align: "left",
        }));
        headerText.position.set(22, 1);
        headerBg.addChild(headerText);

        const closeButton = new Sprite(ENGINE.getTexture("close-icon"));
        closeButton.position.set(headerBg.width - closeButton.width, 1);
        headerBg.addChild(closeButton);
        buttonify(closeButton, {
            onFire: () => {
                mainContainer.visible = false;
            }
        });

        const numOfSlots = 3;
        const sharedTextStyle = new TextStyle({
            fill: 0x070707,
            fontFamily: GAME_FONT,
            fontSize: 14,
        });
        const portraitSlots: Sprite[] = [];
        const displayNameTexts: Text[] = [];
        const rankTexts: Text[] = [];
        const gameModeTexts: Text[] = [];
        const xpTexts: Text[] = [];
        const timestampTexts: Text[] = [];
        const versionTexts: Text[] = [];
        const slotContainers: Container[] = [];
        for(let i = 0; i < numOfSlots; i++) {
            const slot = new Container();
            slotContainers.push(slot);
            slot.position.set(
                16,
                36 + (120 * i),
            );

            const slotBg = new NineSlicePlane(
                ENGINE.getTexture("generic-square-nineslice")
            );
            slotBg.width = bg.width - (slot.position.x * 2);
            slotBg.height = 100;
            slot.addChild(slotBg);

            const indent = 0;

            const portraitSlot = new NineSlicePlane(
                ENGINE.getTexture("inner-container-nineslice")
            );
            portraitSlot.width =
                portraitSlot.height =
                    92;
            portraitSlot.position.set(4, 4);
            slot.addChild(portraitSlot);

            const portraitMask = new Graphics();
            portraitMask.beginFill(0xff0000);
            portraitMask.drawRect(2, 2, portraitSlot.width - 4, portraitSlot.height - 4);
            portraitMask.endFill();
            portraitSlot.addChild(portraitMask);

            const portraitSprite = new Sprite();
            portraitSprite.anchor.set(0.5, 0.5);
            portraitSprite.position.set(
                Math.floor(portraitSlot.width * 0.5),
                Math.floor(portraitSlot.height * 0.5),
            );
            portraitSlot.addChild(portraitSprite);
            portraitSlots.push(portraitSprite);
            portraitSprite.mask = portraitMask;

            const displayNameText = new Text("- Empty save slot -", new TextStyle({
                fill: 0x070707,
                fontFamily: GAME_FONT_BOLD,
                fontSize: 16,
            }));
            displayNameText.position.set(
                portraitSlot.x + portraitSlot.width + 6,
                portraitSlot.y + 0,
            );
            slot.addChild(displayNameText);
            displayNameTexts.push(displayNameText);

            const rankText = new Text("", sharedTextStyle);
            rankText.position.set(
                portraitSlot.x + portraitSlot.width + 6 + indent,
                portraitSlot.y + 22,
            );
            slot.addChild(rankText);
            rankTexts.push(rankText);

            const xpText = new Text("", sharedTextStyle);
            xpText.position.set(
                portraitSlot.x + portraitSlot.width + 6 + indent,
                portraitSlot.y + 56,
            );
            slot.addChild(xpText);
            xpTexts.push(xpText);

            const numberSlotText = new Text("#" + (i+1), new TextStyle({
                fill: 0x0a0a0a,
                fontSize: 11,
                fontFamily: GAME_FONT
            }));
            numberSlotText.position.set(
                slotBg.width - 4,
                2,
            );
            numberSlotText.anchor.set(1, 0);
            slot.addChild(numberSlotText);

            const timestampText = new Text("", numberSlotText.style);
            timestampText.position.set(
                portraitSlot.x + portraitSlot.width + 6,
                slotBg.height - 16,
            );
            slot.addChild(timestampText);
            timestampTexts.push(timestampText);

            const versionText = new Text("", numberSlotText.style);
            versionText.position.set(
                slotBg.width - 4,
                slotBg.height - 2,
            );
            versionText.anchor.set(1, 1);
            slot.addChild(versionText);
            versionTexts.push(versionText);

            const gameModeText = new Text("", Object.assign({}, sharedTextStyle));
            gameModeText.position.set(
                portraitSlot.x + portraitSlot.width + 6 + indent,
                portraitSlot.y + 39,
            );
            slot.addChild(gameModeText);
            gameModeTexts.push(gameModeText);

            bg.addChild(slot);
        }

        return {
            slotContainers,
            displayNameTexts,
            portraitSlots,
            rankTexts,
            gameModeTexts,
            versionTexts,
            timestampTexts,
            xpTexts,
            container: mainContainer
        };
    }
}